/**
 * @desc 请求接口
 */

export const commonConfig = '/webim/innerPage/getCommonConfig';

// 合回SAAS重构通用配置接口
export const COMMON_INFO_URL = '/v1/receptionConf/webim/getCommonInfo';

export const COMPANY_INFO_URL = '/v1/receptionConf/webim/getCompanyInfo';


// 留言表单或者验证码
export const SEND_CAPTCHA = '/reception/leaveMessage/sendCaptcha';
// 留言获取表单配置
export const GET_CUSTOMER_MESSAGE_CONFIG = '/reception/leaveMessage/customerMessageConfig';
// 留言表单提交
export const CREATE_CUSTOMER_MESSAGE = '/reception/leaveMessage/customerMessageCreate';
// 机器人上报
export const ROBOT_ANSWER_REPORT = '/log_processing/data_report/robot_answer_report';

// 加好友卡片信息
export const GET_ADD_FRIEND_SCHEME = '/tp/wpaCall/GetAddFriendProtocol';
// 跳转qq中间页
export const ROUTE_CHANGE_LOADING_QQ = '/template/blue/wpa/link.html';
// 获取跳转qq sign
export const GET_TENCENT_SCHEME = '/tp/wpaCall/getWebProtocol';
// 音视频行为 201，203，205，206
export const POST_VIDEO_CANCEL_REPORT = '/rtc/action/report';
// 音视频小程序开放标签签名
export const VIDEO_WXSDK_SIGNATURE = '/video/wxsdk/signature';
// 音视频小程序跳转urlscheme
export const VIDEO_MINIPROGRAM_URLSCHEME = '/video/mini_program/urlscheme';

// 监测当前主号的webim版本
export const CHECK_IF_WEBIM_V3 = '/v1/interface/inner/cloudcc_303905';

// 机器人延迟回复配置信息
export const ROBOT_REPLAY_DELAY = '/robot/delayReply';

// 机器人电商结构化消息分页获取

export const ROBOT_BUSINESS_TEMPLATE_LIST = '/v1/customerService/robot/getRobotAPIStyleTemplateDataList';
// 电商悬浮卡片
export const GET_QUICK_ORDER_CARD = '/v1/commerce/c/item/get';

// 电商悬浮卡片
export const DISPLAY_MESSAGE_ON_C = '/v1/wpaVisitor/displayMessageOnC';

// 获取老webim漫游消息中的文件消息的COS下载地址
export const GET_FILE_DOWNLOAD_URL_FOR_OLD_MSG = '/v1/interface/inner/cloudcc_303206';

// 消息链路追踪
export const IM_MSG_TRACING_REPORT = '/im_msg_tracing_report';
